<div class="floating-buttons-container" [ngClass]="getCssClasses()" #container >
    <div class="floating-panel" [ngStyle]="getFloatingHeightStyle()" #floating>
      <div class="button-container" [ngStyle]="getTransitionStyle(i)" *ngFor="let btn of this.actions; let i = index">
        <button mat-icon-button  (click)="btn.action(actionParameter)"><mat-icon class="trs-icon" [fontIcon]="btn.icon">{{btn.icon}}</mat-icon></button>
      </div>
    </div>
    <button mat-icon-button class="openbtn"  (click)="toggleExpansion()" (blur)="onBlur()"><mat-icon>{{(expanded ? 'clear' : icon)}}</mat-icon></button>
</div>